import { Session } from 'next-auth';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import BrandDefinition from '@/types/BrandDefinition';
import HeaderDictionary from '@/types/dictionaries/Header';
import BillingProfileMenuHeader from '@/components/Header/components/BillingProfileMenuHeader';
import HeaderDrawer from '../HeaderDrawer';
import AccountMenuList from '../../../AccountMenuList';

interface AccountMenuDrawerProps {
	open: boolean;
	onClose: () => void;
	brand: BrandDefinition;
	sessionData: Session;
	dict: HeaderDictionary;
	showBillingProfileMenuHeader: boolean;
	onSwitchBillingProfile: () => void;
	showInvoicesInAccountMenuList: boolean;
}

export default function AccountMenuDrawer({
	open,
	onClose,
	brand,
	sessionData,
	dict,
	showBillingProfileMenuHeader,
	onSwitchBillingProfile,
	showInvoicesInAccountMenuList,
}: Readonly<AccountMenuDrawerProps>) {
	return (
		<HeaderDrawer
			open={open}
			onClose={onClose}
			brand={brand}
			iconButtonSx={{
				ml: '8px',
				mr: 'auto',
			}}
			anchor="right"
		>
			<Box
				sx={{
					'& .MuiMenuItem-root': {
						borderBottom: '1px solid',
						borderColor: 'grey.light',
					},
				}}
			>
				<Avatar
					sx={{
						bgcolor: 'primary.main',
						color: 'white.main',
						width: '25px',
						height: '25px',
						position: 'absolute',
						top: '27px',
						right: '28px',
					}}
				>
					<Typography variant="h7SemiBold">
						{sessionData.user.firstName.at(0) ?? ''}
						{sessionData.user.lastName.at(0) ?? ''}
					</Typography>
				</Avatar>
				<Divider sx={{ borderColor: 'grey.light' }} />
				{showBillingProfileMenuHeader && (
					<BillingProfileMenuHeader dict={dict} accountMenuType="drawer" onSwitchBillingProfile={onSwitchBillingProfile} />
				)}
				<AccountMenuList dict={dict} showInvoices={showInvoicesInAccountMenuList} handleClose={onClose} />
			</Box>
		</HeaderDrawer>
	);
}
